import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "id"]

  connect() {
    this.suggestions = [
      { name: "Roma", code: "RM", population: "10000", id: 1 },
      { name: "Milano", code: "MI", population: "11100", id: 2 },
      { name: "Torino", code: "TO", population: "89200", id: 3 },
      { name: "Napoli", code: "NA", population: "65500", id: 4 },
      { name: "Firenze", code: "FI", population: "55100", id: 5 },
      { name: "Venezia", code: "VE", population: "12300", id: 6 },
      { name: "Bologna", code: "BO", population: "32500", id: 7 },
      { name: "Genova", code: "GE", population: "67200", id: 8 },
      { name: "Palermo", code: "PA", population: "45200", id: 9 },
      { name: "Catania", code: "CT", population: "5100", id: 10 }
    ]

    // ✅ Ascolta clic fuori dal componente
    document.addEventListener("click", this.closeResultsOutside)
  }

  disconnect() {
    // ✅ Rimuovi il listener quando il controller viene disconnesso
    document.removeEventListener("click", this.closeResultsOutside)
  }

  search() {
    const query = this.inputTarget.value.trim().toLowerCase()
    this.resultsTarget.innerHTML = "" // reset

    if (query === "") return

    const matches = this.suggestions.filter(item =>
      item.name.toLowerCase().includes(query)
    )

    matches.forEach(item => {
      const li = document.createElement("li")
      li.classList.add("list-group-item", "list-group-item-action")

      li.innerHTML = `
        <div><strong>${item.name}</strong></div>
        <small class="text-muted">${item.code} · ${item.population}</small>
      `

      li.addEventListener("click", () => {
        this.inputTarget.value = item.name
        this.idTarget.value = item.id   // ✅ assegna l'ID
        this.resultsTarget.innerHTML = ""
        
        // ✅ Mostra alert con il codice (es. "RM")
        alert(`Hai selezionato: ${item.name} (${item.code}) [${item.id}]`)
      })

      this.resultsTarget.appendChild(li)
    })
  }

  // ✅ Chiude i risultati se clic fuori dal componente
  closeResultsOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.resultsTarget.innerHTML = ""
    }
  }
}
